<template>
    <div class="chatbot-fixed__header">
        <div class="chatbot-fixed__header-title-main">
            <span class="chatbot-fixed__header-title" v-html="$t('Chatbot.title')"></span>
        </div>
        <div class="chatbot-fixed__header-end" v-if="isChatDataLoaded">
            <div
                @click="confirmNewChatSession"
                class="chatbot-fixed__clear-messages icon-bin"
                v-tooltip="{ content: $t('Chatbot.tooltip_clear'), html: true }"
            >
            </div>
            <div
                class="chatbot-fixed__close-button icon-minimize"
                @click="closeChatbot"
                v-tooltip="{ content: $t('Chatbot.tooltip_close'), html: true }"
            >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ChatBotHeader',
        props: {
            isChatDataLoaded: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            confirmNewChatSession () {
                this.$emit('confirm-new-chat-session')
            },
            closeChatbot () {
                this.$store.dispatch('ChatBotCombo/setShowChatModal', false)
                setTimeout(() => {
                    this.$store.dispatch('ChatBotCombo/setCurrentChatMode', null)
                }, 200)
            },
        }
    }
</script>
<style lang="scss" scoped>
    .chatbot-fixed {
        &__tooltip {
            background: $tundora;
            text-align: center;
            color: $white;
            font-family: Nunito-Regular, sans-serif;
        }

        .icon-spinner {
            padding: 20px;
        }

        &__header {
            background: linear-gradient(91.62deg, #973F00 0%, #C65300 100%);
            height: 60px;
            align-items: center;
            display: flex;
            gap: 15px;
            justify-content: space-between;
            padding: 10px 20px;
            z-index: 2000;

            [class="mobile_sm"] & {
                border-radius: 0;
            }

        }

        &__header-end {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        &__header-title {
            font-size: 1.6rem;
            font-family: Quicksand-Bold,  sans-serif;
            color: $white;
            display: flex;
            line-height: 20px;

            [class="mobile_sm"] & {
                font-size: 1.4rem;
            }
        }

        &__close-button {
            width: 4rem;
            height: 4rem;
            color: $white;
            font-size: 3rem;
            margin: 0;
            padding: 8px;
            border-radius: 3px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover {
                background: rgba(255, 255, 255, 0.2);
            }
        }

        &__clear-messages {
            width: 4rem;
            height: 4rem;
            color: $white;
            font-size: 2rem;
            margin: 0;
            border-radius: 3px;
            cursor: pointer;
            padding: 8px;
            display: flex;
            justify-content: center;
            align-items: center;

            &:hover {
                background: rgba(255, 255, 255, 0.2);
            }
        }

        &__go-back-button {
            color: $white;
            font-size: 2rem;
            margin: 0;
            border-radius: 3px;
            cursor: pointer;
            padding: 8px;
            margin: 0 5px;

            &:hover {
                background: rgba(255, 255, 255, 0.2);
            }
        }

    }
</style>
